const playupTheme = require('./playupTheme');

module.exports = {
  build: {
    files: {
      imageDir: 'playup'
    },
    meta: {
      ogImage: 'https://play.playchipfantasy.com/ogimage.jpg',
      title: 'PlayChip Fantasy',
      url: 'https://www.playchipfantasy.com'
    },
    scripts: [
      {
        src: 'https://www.googletagservices.com/tag/js/gpt.js',
        async: true
      }
    ]
  },
  app: {
    default: {
      settings: {
        availableBonuses: ['daily-bonus', 'daily-spins'],
        appLinks: [],
        chatURI: 'https://chat.sportsfantasyhq.com',
        content: {
          howToPlay: {
            tagline: 'PlayChip Fantasy is 100% **free&nbsp;to&nbsp;play**',
            bannerDesktop: '/images/howtoplay/desktop/banner.jpg',
            bannerMobile: '/images/howtoplay/mobile/banner.png',
            htmlTitle: 'How to Play - Fantasy Games - Fantasy Sports League',
            description:
              'PlayChip Fantasy is 100% Free to Play. Learn how to play your favourite fantasy sports today.',
            pages: [
              {
                title: 'Step 1 - Choose your\u00A0challenge',
                description:
                  'Are you ready to play your favourite fantasy sports and win prizes at the same time? Go to the lobby, filter by sport and choose your challenge!',
                desktopImages: [
                  '/images/howtoplay/desktop/step1.png',
                  '/images/howtoplay/desktop/step1@2x.png'
                ],
                mobileImages: [
                  '/images/howtoplay/mobile/step1.png',
                  '/images/howtoplay/mobile/step1@2x.png'
                ],
                frame: true
              },
              {
                title: 'Step 2 - Select your\u00A0players',
                description:
                  "Create your lineup of players while staying within the salary cap. Which players are in good form? Who is due for a big game? What's your selection strategy?",
                desktopImages: [
                  '/images/howtoplay/desktop/step2.png',
                  '/images/howtoplay/desktop/step2@2x.png'
                ],
                mobileImages: [
                  '/images/howtoplay/mobile/step2.png',
                  '/images/howtoplay/mobile/step2@2x.png'
                ],
                frame: true
              },
              {
                title: 'Step 3 - Watch the action\u00A0live',
                description:
                  'This is where the excitement really starts! Your players accrue points based on their real life performance. Make sure you keep an eye on the live leaderboard as you climb to number&nbsp;one!',
                desktopImages: [
                  '/images/howtoplay/desktop/step3.gif',
                  '/images/howtoplay/desktop/step3.gif'
                ],
                mobileImages: [
                  '/images/howtoplay/mobile/step3.png',
                  '/images/howtoplay/mobile/step3@2x.png'
                ],
                frame: true
              }
            ]
          },
          about: {
            htmlTitle: 'About Us - PlayChip Fantasy Sports',
            description:
              'Join PlayChip Fantasy & play fantasy sports like daily fantasy basketball, football, cricket, hockey, soccer & many more. All our games & challenges are always free-to-play.'
          },
          contactUs: {
            htmlTitle: 'Contact Us - PlayChip Fantasy Games & Sports',
            description:
              'Contact PlayChip Fantasy or Sign Up today to start playing your favourite fantasy sports & fantasy games online.'
          },
          lobby: {
            htmlTitle: 'Lobby - Play Daily Fantasy Sports - Fantasy League',
            description:
              'Sign Up & join PlayChip Fantasy! Free to play, no deposit, no risk & win real prize money. Play all of the major fantasy sports leagues.'
          }
        },
        darkMode: true,
        filters: {
          theme: 'dark',
          complexity: true,
          entrants: true,
          fee: false,
          payout: true,
          size: true,
          entrantsOptions: [2, 15, 50, 100, 500, null]
        },
        hasLightBackground: false,
        // challengeCategories: ['all', 'featured', 'paid', 'h2h'],
        displayBalanceOnFreeMode: true,
        displayCountry: true,
        displayFriends: true,
        displayGamblingHelp: false,
        displayGiftStore: false,
        displayGlobalLeaderboard: true,
        displayJackpotSlots: true,
        displayLoadLineup: true,
        displayLobbyBanner: true,
        displayMyTeams: true,
        displayPromotionModal: true,
        displayTraining: false,
        displayUserQuestions: false,
        displayVerificationLink: true,
        mustVerifyPhoneToEnterPaidChallenge: false,
        enableAccountLimit: false,
        enableAdditionalInfoOnContactUs: true,
        enableMobileVerification: false,
        enableUploadLineup: false,
        onesportPlatform: 1,
        doubleClick: {
          challengeFooter: {
            xsmall: {
              id: 'gpt-ad-challenge-footer-xsmall',
              path: '/21624600003/PlayUpGlobal320x50',
              height: 50,
              width: 320
            }
          },
          chat: {},
          entryConfirmation: {
            xsmall: {
              id: 'gpt-ad-entry-confirmation-xsmall',
              path: '/21624600003/PlayUpGlobal300x250',
              height: 250,
              width: 300
            }
          },
          entrySuccess: {
            xsmall: {
              id: 'gpt-ad-entry-success-xsmall',
              path: '/21624600003/PlayUpGlobal300x250',
              height: 250,
              width: 300
            }
          },
          // lobbyFooter: {
          //   xsmall: {
          //     id: 'gpt-ad-lobby-footer-xsmall',
          //     path: '/21624600003/PlayUpGlobal320x50',
          //     height: 50,
          //     width: 320,
          //   },
          // },
          // lobbyModal: {
          //   xsmall: {
          //     id: 'gpt-ad-lobby-modal-xsmall',
          //     path: '/21624600003/PlayUpGlobal300x250',
          //     height: 250,
          //     width: 300,
          //   },
          // },
          header: {
            xsmall: {
              id: 'gpt-ad-header-xsmall',
              path: '/21624600003/PlayUpGlobal320x50',
              height: 50,
              width: 320
            },
            medium: {
              id: 'gpt-ad-header-medium',
              path: '/21624600003/PlayUpGlobal',
              height: 90,
              width: 728
            }
          },
          rhs: {
            xlarge: {
              id: 'gpt-ad-rhs-xlarge',
              path: '/21624600003/PlayUpGlobal160x600',
              height: 600,
              width: 160
            }
          },
          signin: {
            xsmall: {
              id: 'gpt-ad-signin-xsmall',
              path: '/21624600003/PlayUpGlobal300x250',
              height: 250,
              width: 300
            }
          }
        },
        enablePxc: true,
        facebookAppId: '1277212069000706',
        freeOnly: true,
        giftStoreName: 'PlayChip Fantasy Store',
        googleMapsAPIKey: 'AIzaSyDDPHiDw3zDk8sHrt9j2E_9g6y7Lz9PaJY',
        googlePlayURI: 'https://play.google.com/store/apps/details?id=com.playup.app',
        hasSMSLogin: false,
        social: {
          messages: {
            enteredAndOpen: "I've entered this challenge, come join me!",
            enteredAndInProgress:
              "If you're not first, you're last! Check out the Live Leaderboard!",
            enteredAndCompleted:
              'Run and won. What a game! Check out the Leaderboard to see who cashed in!',
            notEntered: 'No excuses, play like a champion!'
          },
          twitterVia: undefined,
          twitterHashtags: ['__SPORT_NAME__Fantasy']
          // twitterUrl: 'https://twitter.com/PlayUpGlobal',
          // facebookUrl: 'https://www.facebook.com/playupglobal/',
          // instagramUrl: 'https://www.instagram.com/playupglobal/'
        },
        verificationUri: 'https://content.playup.com/verification',
        copyright: '© 2019 PlayChip Fantasy. All Rights Reserved.',
        onesport: true,
        logoImage: '/images/logo-header-new.svg',
        promo: [
          {
            link: 'https://www.playchip.com',
            desktopSrc: '/images/carousel-desktop/playchip_now_live.png',
            mobileSrc: '/images/carousel-mobile/playchip_now_live.jpg'
          },
          {
            link: '/how-to-play',
            desktopSrc: '/images/carousel-desktop/how_to_play.png',
            mobileSrc: '/images/carousel-mobile/how_to_play.jpg'
          },
          {
            desktopSrc: '/images/carousel-desktop/cricket_scoring.jpg',
            mobileSrc: '/images/carousel-mobile/cricket_scoring.jpg'
          }
        ],
        siteName: 'PlayChip Fantasy',
        secondaryLinks: [
          {
            title: 'About',
            items: [
              {
                type: 'route',
                href: '/about',
                name: 'About',
                category: 'more',
                icon: 'icon_menu_about'
              }
            ]
          },
          {
            title: 'Help',
            items: [
              {
                type: 'route',
                href: '/how-to-play',
                name: 'How to Play',
                category: 'more',
                icon: 'icon_menu_how_to_play'
              },
              {
                type: 'route',
                href: '/rules',
                name: 'Rules',
                category: 'more',
                icon: 'icon_menu_rules'
              },
              {
                type: 'route',
                href: '/faqs',
                name: 'FAQs',
                category: 'more',
                icon: 'icon_menu_faqs'
              },
              {
                type: 'route',
                href: '/contact-us',
                name: 'Contact Us',
                category: 'more',
                icon: 'icon_menu_contact'
              }
            ]
          },
          {
            title: 'More',
            items: [
              {
                type: 'route',
                href: '/terms',
                name: 'Terms & Conditions',
                category: 'more',
                icon: 'icon_menu_terms_conditions'
              },
              {
                type: 'route',
                href: '/privacy-policy',
                name: 'Privacy Policy',
                category: 'more',
                icon: 'icon_menu_privacy_policy'
              }
            ]
          }
        ]
      },
      theme: playupTheme.theme,
      skin: playupTheme.skin
    },
    development: {
      settings: {
        dataSource: 'http://pro-api.staging.sportsfantasyhq.com',
        onesportSource: 'https://onesport-admin.sportsfantasyhq.com',
        verificationUri: 'https://pro-content.staging.sportsfantasyhq.com/verification',
        pxcUrl: 'http://localhost:3001',
        pxcPartnerId: 'cd80271d-14c7-4faa-bfe3-4dc1fcc50bdd',
        siteUrl: 'https://playup.sportsfantasyhq.com'
      }
    },
    staging: {
      settings: {
        dataSource: 'http://pro-api.staging.sportsfantasyhq.com',
        onesportSource: 'https://onesport-admin.sportsfantasyhq.com',
        verificationUri: 'https://pro-content.staging.sportsfantasyhq.com/verification',
        pxcUrl: 'https://playxchange-sandbox.now.sh',
        pxcPartnerId: '76e014ea-049d-4efe-aa59-54828a2efca9',
        siteUrl: 'https://playup.sportsfantasyhq.com'
      }
    },
    production: {
      settings: {
        chatURI: 'https://chat.playup.com',
        dataSource: 'https://api.playup.com',
        onesportSource: 'https://onesport-api.playup.io',
        googleTagManagerId: 'GTM-NC2P5SW',
        verificationUri: 'https://content.playup.com/verification',
        pxcUrl: 'https://app.playxchange.global',
        pxcPartnerId: '341065d2-487c-4f8d-9187-d2abf595bc41',
        siteUrl: 'https://play.playchipfantasy.com'
      }
    }
  }
};
